'use client'

import { AppProgressBar as ProgressBar } from 'next-nprogress-bar'

export const PageNavigationProgress = () => {
  return (
    <ProgressBar
      height='3px'
      color='#0096FF'
      shallowRouting
    />
  )
}
